module.exports = __webpack_public_path__ + "img/ccic.796deb8f.jpg";